import { type PartialPropsOf } from '@blaze-runtime/engine-domain';

import {
  getClearElementContentOverridesPropsPatchWithSimpleAlign,
  shouldPatchProp,
} from '../../utils/elements/props-builder.utils';
import { PropsBuilder } from '../__base/props-builder';
import {
  type FormChildrenContentOverrides,
  type FormChildrenStyleOverrides,
} from '../form-container/form-container.model';

export class PdfViewerPropsBuilder extends PropsBuilder<'pdfViewer'> {
  override setParentContentProps = (
    elementProps: PartialPropsOf<'pdfViewer'>,
    overrides: FormChildrenContentOverrides | null,
    initialValues?: PartialPropsOf<'pdfViewer'>,
  ): this => {
    if (overrides === null) {
      this.patchProps(getClearElementContentOverridesPropsPatchWithSimpleAlign());
      return this;
    }

    if (
      shouldPatchProp(overrides.label?.align, 'content.title.align', elementProps, initialValues)
    ) {
      this.patchProps({ content: { title: { align: overrides.label.align } } });
    }

    return this;
  };

  override setParentStyleProps = (
    elementProps: PartialPropsOf<'pdfViewer'>,
    overrides: FormChildrenStyleOverrides | null,
    initialValues?: PartialPropsOf<'pdfViewer'>,
  ): this => {
    if (overrides === null) {
      this.patchProps({
        style: {
          label: undefined,
          border: undefined,
        },
      });
      return this;
    }

    const { titleLabel, fieldBox } = overrides;

    if (shouldPatchProp(titleLabel?.color, 'style.label.color', elementProps, initialValues)) {
      this.patchProps({ style: { label: { color: titleLabel.color } } });
    }

    if (shouldPatchProp(fieldBox?.outline, 'style.border.outline', elementProps, initialValues)) {
      this.patchProps({ style: { border: { outline: fieldBox.outline } } });
    }
    if (
      shouldPatchProp(fieldBox?.outlineWidth, 'style.border.width', elementProps, initialValues)
    ) {
      this.patchProps({ style: { border: { width: fieldBox.outlineWidth } } });
    }
    if (shouldPatchProp(fieldBox?.radius, 'style.border.radius', elementProps, initialValues)) {
      this.patchProps({ style: { border: { radius: fieldBox.radius } } });
    }

    return this;
  };

  constructor(props: PartialPropsOf<'pdfViewer'> | undefined) {
    super(props, { hasData: true, hasLabel: true });
  }
}
